import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import ActionBar from '../../components/ActionBar'
import Search from '../../components/Search'
import Button from '../../components/shared/Button'
import { AddIcon } from '../../components/shared/Icons'
import Loader from '../../components/shared/Loader'
import Pagination from '../../components/shared/Pagination'
import Table from '../../components/Table'
import useFetch from '../../hooks/useFetch'
import CaptionLayout from '../../layouts/CaptionLayout'
import Section from '../../layouts/Section'
import SectionBody from '../../layouts/SectionBody'
import { getAllProducts } from '../../utils/Apis/products'
import { cn } from '../../utils/helperFunctions'
import { withErrorHandling } from '../../utils/withErrorHandling'
import { columns } from './COLUMNS'

const Products = ({ className, ...props }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [search, setSearch] = useState('')
  const [sortProduct, setSortProduct] = useState('old') // Default to 'old' to 'new'

  const fetchFn = useMemo(() => (search, currentPage, sortProduct) =>
    getAllProducts(search, currentPage, sortProduct), [])

  const { data, error, loading, refetch } = useFetch({
    fn: fetchFn,
  })

  const handleSearch = withErrorHandling(async (search) => {
    refetch(search, currentPage, sortProduct)
  })

  const fetchProducts = useCallback(() => {
    refetch(search, currentPage, sortProduct)
  }, [search, currentPage, sortProduct, refetch])

  useEffect(() => {
    document.title = 'Products - Admin'
  }, [])

  useEffect(() => {
    fetchProducts()
  }, [fetchProducts])

  return (
    <div className={cn('', className)} {...props}>
      <Section title={'Products'} className={'lg:pb-2'}>
        <Search
          handleSearch={handleSearch}
          search={search}
          setSearch={setSearch}
          className={'top-0'}
        />
        <ActionBar className={'top-0'}>
          <div className="flex justify-start w-full">
              <Button className={'mr-2'} onClick={() => setSortProduct('new')}>Sort by New</Button>
              <Button onClick={() => setSortProduct('old')}>Sort by Old</Button>
          </div>
          <NavLink to={'/products/new'}>
            <Button>
              <AddIcon className={'h-6 w-6'} />
              Add Product
            </Button>
          </NavLink>
        </ActionBar>
      </Section>

      {loading ? (
        <Loader />
      ) : error ? (
        <p>Error</p>
      ) : (
        <SectionBody>
          <CaptionLayout
            results={data?.totalCount}
            caption={'Products present'}
          >
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={data?.paginationResult?.numberOfPages}
              showGoToPage={true}
            />
          </CaptionLayout>
          <div
            className={cn(
              'custom-scroll relative max-h-[45vh] w-full overflow-auto md:max-h-[60vh]',
              className,
            )}
            {...props}
          >
            <Table data={data?.data} columns={columns} />
            {/* Fade */}
            <div className="pointer-events-none sticky bottom-0 left-0 h-16 w-full bg-gradient-to-t from-background to-transparent" />
          </div>
        </SectionBody>
      )}
    </div>
  )
}

export default Products
